import { createApp } from "vue";
import * as Sentry from "@sentry/vue";

import App from "./App.vue";
import ElementPlus from "element-plus";
import "element-plus/dist/index.css";
import "./style.css";

import router from "./router";
import i18n from "./i18n/i18n";

const app = createApp(App);
Sentry.init({
  app,
  dsn: "https://52bb2185c4244e4c8789ec4fa31c656e@o4507973331910656.ingest.de.sentry.io/4509841096704081",
  debug: true,
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
  denyUrls: [],
  allowUrls: [],
  integrations: [
    Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
        networkDetailAllowUrls: [/webapinew/i],
        networkRequestHeaders: ['X-Custom-Header'],
        networkResponseHeaders: ['X-Custom-Header'],
        networkCaptureBodies: true,
        beforeAddRecordingEvent: (event: any) => {
            if (['bam.eu01.nr-data.net', 'smartlook', 'posthog', 'google'].some(url => event?.data?.payload?.description?.includes(url))) {
                return null
            }

            return event
        },
      },
    )
  ],
  // Session Replay
  tracesSampleRate: 1.0,
  replaysSessionSampleRate: 1.0, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0 // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});



app.use(ElementPlus);
app.use(router);
app.use(i18n);

app.mount("#app");
